import ErrorPage from './Index.vue'

ErrorPage.install = function(Vue) {
  Vue.component(ErrorPage.name, ErrorPage)
}

export default ErrorPage
